import React from 'react'
import DocumentTitle from 'react-document-title'

import styles from './styles.css'

import dylanImg from './dylan.jpg'
import kevinImg from './kevin.jpg'
import tinoImg from './tino.jpg'
import sachaImg from './sacha.jpg'
import chelseyImg from './chelsey.jpg'
import paddyImg from './paddy.jpg'

import ethanImg from './ethan.jpg'
import lyndseyImg from './lyndsey.jpg'
import katieImg from './katie.jpg'
import mariaImg from './maria.jpg'
import kateImg from './kate.jpg'
import emilyImg from './emily.jpg'

class PartyMember extends React.Component {
	render () {
		return (
			<li className={styles.partyMember}>
				<div><img src={this.props.picture} alt={this.props.name} className={styles.avatar} />
					<h4 className={styles.name}>{this.props.name}</h4>
					<h5 className={styles.role}>{this.props.role}</h5>
				</div>
				<div className={styles.bio}>
					{this.props.children}
				</div>
			</li>
		)
	}
}

class Party extends React.Component {
	static paddyParty = [
		{name: 'Paddy Foran', role: 'Groom', picture: paddyImg, bio: 'Paddy met Ethan in college, when he was a resident on Ethan’s floor. He works as a software engineer, bakes way too many cupcakes, and reads not enough books.'},
		{name: 'Dylan Staley', role: 'Best Man', picture: dylanImg, bio: 'Paddy and Dylan met at a software conference. Well, on Twitter before the conference. It’s a long story, ask him about it. They became fast friends, working together occasionally. A three-time Guinness World Record holder, Dylan’s claim to fame is still his puppy, Jpeg.'},
		{name: 'Sacha Brady', role: 'Groomsmaid', picture: sachaImg, bio: 'Sacha and Paddy et when she started using Paddy’s software. As she reached out and engaged more around it, they struck up a friendship. It was Sacha who patiently fielded the hours-long “should I marry this guy?” phone call (...she said “yes”).'},
		{name: 'Kevin Purdy', role: 'Groomsman', picture: kevinImg, bio: 'Kevin accidentally began Paddy’s career in software when he published an article about software Paddy wrote. They discovered they lived in the same city, and met up. They kept running into each other, and their friendship grew. Kevin is affectionately known as "Dad" sometimes.'},
		{name: 'Chelsey Lonberger', role: 'Groomsmaid', picture: chelseyImg, bio: 'A friend from college, Chelsey is Paddy’s baking partner in crime. Her recommendations on TV shows are impeccable and always to be trusted. Much of their friendship has been spent building Legos on the floor.'},
		{name: 'Tino Galizio', role: 'Groomsman', picture: tinoImg, bio: 'Tino’s Paddy’s original business partner. A friend from college, they worked closely for years, and Tino never once throttled Paddy. Tino’s a reliable source of board game suggestions and hilarious-but-somehow-true stories. Ask him about being thrown out of the smallest country in the world.'},
	]
	static ethanParty = [
		{name: 'Ethan Carver', role: 'Groom', picture: ethanImg, bio: 'Ethan met Paddy while he was Paddy’s resident assistant. Paddy commented on the pop-punk music Ethan was subjecting the floor to, and they’ve been friends ever since. Ethan loves to talk about animal behaviour, is a big fan of zoos, and thinks his puppy Roxy is objectively the best dog in the world.'},
		{name: 'Lyndsey Pierson', role: 'Maid of Honour', picture: lyndseyImg, bio: 'Ethan and Lyndsey met as freshman biology majors in college. They bonded over taking far too many classes at once and sharing hilarious bumper stickers on Facebook. They quickly became best friends, drawn together by late night study sessions fueled by Tim Hortons.'},
		{name: 'Katie Caputo', role: 'Groomsmaid', picture: katieImg, bio: 'Katie and Ethan met through a mutual friend (who you will see officiating the wedding). They share a love for Parks and Recreation, video games, and animal rescue. They can often be found arguing about whether PlayStation or Xbox is better, and who has the cutest pets (it\'s Roxy, by the way).'},
		{name: 'Maria Hayes', role: 'Groomsmaid', picture: mariaImg, bio: 'Maria and Ethan met in kindergarten, but they didn’t become friends until high school, when they started working on school musicals together. She moved to Astoria after college, where she was perfectly positioned to help Paddy propose.'},
		{name: 'Kate Des Jardin', role: 'Groomsmaid', picture: kateImg, bio: 'As Kate is Ethan’s cousin, they’ve technically always known each other. Only separated in age by six months, they have always been close, even developing shared interests in biological and environmental sciences.'},
		{name: 'Emily Hayes', role: 'Groomsmaid', picture: emilyImg, bio: 'Emily met Ethan while they were working stage crew on their high school’s musical, and they continued working backstage together for years. Being good friends with both Emily and Maria meant Ethan was often causing mischief at the Hayes’ house.'},
	]

	render() {
		return (
			<DocumentTitle title='Wedding Party'>
				<article className={styles.content}>
					<h2 className='title'>Wedding Party</h2>
					<div className={styles.parties}>
						<ol className={styles.party}>
							{Party.paddyParty.map((item, index) => {
								return <PartyMember key={index} name={item.name} role={item.role} picture={item.picture}><p>{item.bio}</p></PartyMember>
								})}
							</ol>
							<ol className={styles.party}>
								{Party.ethanParty.map((item, index) => {
									return <PartyMember key={index} name={item.name} role={item.role} picture={item.picture}><p>{item.bio}</p></PartyMember>
									})}
								</ol>
							</div>
				</article>
			</DocumentTitle>
		)
	}
}

export default Party



// WEBPACK FOOTER //
// ./client/components/Party/index.jsx